import React from "react";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";
import Switch from "../Switch";
import ArgumentSubCon from "./ArgumentSubCon";
import Utility from './../../utilities/Utility';

export default class RouterArgumentSubCon extends ArgumentSubCon {
    /**
     * Submenu view for tabular router node input
     * @module RouterArgumentSubCon
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel(){
        return {
            argumentName: null,
            type: "variable",
            value: null,
            varName: null,
            id: Utility.uuid4(),
            sensitiveData:false,
            ignoreCase:false
        };
    }

    isValidModel(){
        return this.varModel.argumentName &&
            (this.varModel.value || (this.varModel.varName && this.isValidVar()));
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const colSelection = window.apm.knowledgeBase.getIndexFromValue(this.varModel.argumentName, this.props.params.colOptions);
        const preSelection = window.apm.knowledgeBase.getNodeInputTypeIndexFromValue(this.varModel.type);

        return (
            <div>
                {<Dropdown 
                    context={this} 
                    label={this.getPropLabel("column_to_match")} 
                    optionName={this.getPropLabel("select_column")}
                    options={this.props.params.colOptions} 
                    valKey={"argumentName"}
                    selection={colSelection}
                    suppressUpdate={true}
                />}

                {<Dropdown 
                    wide={true} 
                    label={this.getPropLabel("match_with")} 
                    optionName={this.getPropLabel("type_opt")}
                    options={window.apm.knowledgeBase.getNodeInputTypes()}
                    context={this} 
                    valKey={"type"}
                    selection={preSelection} 
                    suppressUpdate={true}
                />}
                           
                {this.varModel.type === "value" &&
                    <Input 
                        label={this.getPropLabel("argument_value")} 
                        hint={this.getPropLabel("argument_value_hint")}
                        context={this} 
                        valKey={"value"} 
                        value={this.varModel.value}
                        suppressUpdate={true}
                    />
                }
                {this.varModel.type === "variable" &&
                    <Input 
                        label={this.getPropLabel("scoped_variable_name")} 
                        hint={this.getPropLabel("scoped_variable_name_hint")} 
                        context={this} 
                        valKey={"varName"} 
                        value={this.varModel.varName} 
                        valRules={{ "varName": true }} 
                        suggestion={"variable"}
                        suppressUpdate={true}
                    />
                }
                <Switch 
                    context={this}
                    label={this.getPropLabel("ignore_case")} 
                    valKey={"ignoreCase"} 
                    checked={this.varModel.ignoreCase}
                    key={"igonreCase"} 
                    disabled={this.props.context.props.context.props.isCommonModule}
                    suppressUpdate={true}  
                />
                {(() => {
                    if (this.isKnownModel()) {
                        // Display edit and delete for editing
                        return (
                            <table style={{width: "100%"}}><tbody><tr>
                                <td style={{paddingRight: "2px"}}>
                                    {<Button icon={"icon-trash"} tint={"warning"}
                                             callback={() => {
                                                 this.props.context.remove(this.varIdx);
                                                 this.varModel = this.initVarModel();
                                                 this.props.domContext.removeSubmenu();
                                             }}
                                    />}
                                </td>
                                <td>
                                    {<Button label={this.getPropLabel("save_rule")} wide={true}
                                             callback={() => {
                                                 if (this.isValidModel()){
                                                     this.props.context.update(this.varModel, this.varIdx);
                                                 }
                                                 this.varModel = this.initVarModel();
                                                 this.props.domContext.removeSubmenu();
                                             }}
                                    />}
                                </td>
                            </tr></tbody></table>
                        );
                    }
                    return (
                        <Button label={this.getPropLabel("add_rule")} wide={true}
                                callback={() => {
                                    if (this.isValidModel()) {
                                        // Add current data model to item list
                                        this.props.context.add(this.varModel);
                                    }
                                    this.props.domContext.removeSubmenu();
                                }}
                        />
                    );
                })()}
            </div>
        );
    }
}